import { render, staticRenderFns } from "./DwOverallTotalPolicies.vue?vue&type=template&id=80a911d2&"
import script from "./DwOverallTotalPolicies.vue?vue&type=script&lang=js&"
export * from "./DwOverallTotalPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports